export default __webpack_public_path__ + "static/media/cc_scrnsht.b574397e.png";